module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAABDklEQVRIie2VzU3EMBCFvyCumO0Abj4SOqAEOiB7dw8sNeA7SweUsB2w3JgbdLDrBswBJ7KCnT+yaA88aaTYeXqfZ2QlhfeeQ+rkoOl/DlBWZp/XcYxIWSmVlZ2yUnV4FsrKdjRAWSmBDXAOPCkrq4znA7gaBVBWFsBLCK91r6ysI08FvLY8jU57wjfAReL1nbLSPHcdMgmIwn+0HEO6gmvlRtQXPljJDpzR5RzhWUC4bpM6cEYX8To3ohvgbQqgrSTAGb0bAHkONR7Qgnymwp3RlTO6ApaTABHkFthH2w8huPasgeuWZxggBGz57mQPLJ3Rq4znktRIvfdNnT2++3g9Rx3H5/o3Kv5/+n36AqTul/3Q46KdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_area_mirror_blue.png
// module id = 337
// module chunks = 1